import { createContext, useContext } from "react";
var LoginContext = /*#__PURE__*/ createContext(null);
var useLogin = function() {
    var context = useContext(LoginContext);
    if (context === null) {
        throw new Error("Ensure you have wrapped the login form in a LoginProvider");
    }
    return context;
};
export { LoginContext, useLogin };
